
import Http from 'axios'
import API from '@/config/API-config'
// import store from '../store/index.js'
const encodeParams = params => {
  const r = '?'
  const p = []
  for (const key in params) {
    p.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  }
  return r + p.join('&')
}

// 请求类
class ApiService {
  constructor() {
    // 登录/获取侧边栏接口
    this.user = {
      getuserlist: this.get.bind(this, API.USER.getuserlist),
      loginOctopus: this.post.bind(this, API.USER.loginOctopus),
      getAuth: this.post.bind(this, API.USER.getAuth),
      getSysMessage: this.post.bind(this, API.USER.getSysMessage),
      updateNotice: this.post.bind(this, API.USER.updateNotice),
      getAlertList: this.post.bind(this, API.USER.getAlertList),
      CheckUserTokenValidity: this.get.bind(this, API.USER.CheckUserTokenValidity),
      updateConcernsMsg: this.post.bind(this, API.USER.updateConcernsMsg),
      warnMsg: this.post.bind(this, API.USER.warnMsg),
    }
    this.tree = {
      first: this.post.bind(this, API.TREE.first),
      treeson: this.post.bind(this, API.TREE.treeson),
      guids: this.post.bind(this, API.TREE.guids),
      property: this.post.bind(this, API.TREE.property),
      add: this.post.bind(this, API.TREE.add),
      update: this.post.bind(this, API.TREE.update),
      devicelist: this.post.bind(this, API.TREE.devicelist),
      deletedevice: this.post.bind(this, API.TREE.deletedevice),
      addextraprop: this.post.bind(this, API.TREE.addextraprop),
      removeExtraProp: this.post.bind(this, API.TREE.removeExtraProp),
      getcctvdatalist: this.post.bind(this, API.TREE.getcctvdatalist),
      getcctvTypeData: this.get.bind(this, API.TREE.getcctvTypeData),
      getYsToken: this.get.bind(this, API.TREE.getYsToken),
      addwarningsetting: this.post.bind(this, API.TREE.addwarningsetting),
      gethistorydeviceData: this.post.bind(this, API.TREE.gethistorydeviceData),
      getModelLocationData: this.post.bind(this, API.TREE.getModelLocationData),
      updateModelLocationData: this.post.bind(this, API.TREE.updateModelLocationData),
      getOpticDeviceList: this.post.bind(this, API.TREE.getOpticDeviceList)
    }
    this.FactData = {
      factDataPage: this.post.bind(this, API.FactData.factDataPage),
      addentering: this.post.bind(this, API.FactData.addentering),
      addfactdata: this.post.bind(this, API.FactData.addfactdata)
    }
    this.oct_doc = {
      getDocList: this.post.bind(this, API.octopus_doc.getDocList), // 获得文件和文件夹列表
      deleteFile: this.post.bind(this, API.octopus_doc.deleteFile), // 删除文件
      upload: this.post.bind(this, API.octopus_doc.upload), // 上传文件
      downLoad: this.post.bind(this, API.octopus_doc.downLoad), // 下载文件
      updateDoc: this.post.bind(this, API.octopus_doc.updateDoc), // 更新文件
      fileRename: this.post.bind(this, API.octopus_doc.fileRename), // 文件重命名
      getTagById: this.get.bind(this, API.octopus_doc.getTagById), // 通过文件ID获取标签列表
      setFileListTags: this.post.bind(this, API.octopus_doc.setFileListTags), // 批量给文件设置标签
      setFileTags: this.post.bind(this, API.octopus_doc.setFileTags), // 给文件设置标签
      getFolderChildren: this.post.bind(this, API.octopus_doc.getFolderChildren),
      fileUpdate: this.post.bind(this, API.octopus_doc.fileUpdate),
      createFolder: this.post.bind(this, API.octopus_doc.createFolder),
      searchDoc: this.post.bind(this, API.octopus_doc.searchDoc),
      common: this.post.bind(this, API.octopus_doc.common),
      GetTopFolderId: this.get.bind(this, API.octopus_doc.GetTopFolderId),
      getDocInfoByFid: this.post.bind(this, API.octopus_doc.getDocInfoByFid)
    }
    this.doc = {
      fileConcat: this.post.bind(this, API.DOC.fileConcat), // 关联文件
      fileCheck: this.post.bind(this, API.DOC.fileCheck), // 关联文件
      cancelConcat: this.post.bind(this, API.DOC.cancelConcat), // 取消关联文件
      fileUpdateCheck: this.post.bind(this, API.DOC.fileUpdateCheck), // 关联文件
      fileNameUpdate: this.post.bind(this, API.DOC.fileNameUpdate), // 更新文件
      searchDocByBitNum: this.post.bind(this, API.DOC.searchDocByBitNum), // 搜索文件
      getModelData: this.post.bind(this, API.DOC.getModelData),
      getBitById: this.post.bind(this, API.DOC.getBitById),
      attrSearch: this.post.bind(this, API.DOC.attrSearch),
      setAngel: this.post.bind(this, API.DOC.setAngel),
    }
    this.person_doc = {
      getPersonDoc: this.post.bind(this, API.personDrive.getPersonDoc),
      addNewFolder: this.post.bind(this, API.personDrive.addNewFolder),
      addPersonDoc: this.post.bind(this, API.personDrive.addPersonDoc),
      reFileName: this.post.bind(this, API.personDrive.reFileName),
      fileDownload: this.post.bind(this, API.personDrive.fileDownload),
      delFile: this.post.bind(this, API.personDrive.delFile)
    }
    this.octopus_user = {
      getUserInfo: this.post.bind(this, API.USER.getUserInfo), // octopus
      logOut: this.post.bind(this, API.USER.logOut), // octopus
      systemManage: this.get.bind(this, API.USER.systemManage),
      getAllUser: this.post.bind(this, API.USER.getAllUser),
      editUser: this.post.bind(this, API.USER.editUser),
      changePwd: this.post.bind(this, API.USER.changePwd),
      faceTest: this.post.bind(this, API.USER.faceTest),
      verifyFace: this.post.bind(this, API.USER.verifyFace)
    }
    this.draw = {
      GetThreeDrawingData: this.post.bind(this, API.DRAW.GetThreeDrawingData),
      GetTwoDrawingData: this.post.bind(this, API.DRAW.GetTwoDrawingData),
      GetCadDataList: this.post.bind(this, API.DRAW.GetCadDataList),
      getCadListByBit: this.post.bind(this, API.DRAW.getCadListByBit),
    }
    this.map = {
      GetGpsData: this.post.bind(this, API.MAP.GetGpsData),
      InspectData: this.post.bind(this, API.MAP.InspectData),
      ScreenTodayIdseatData: this.post.bind(this, API.MAP.ScreenTodayIdseatData),
      DelTodayIdseatData: this.post.bind(this, API.MAP.DelTodayIdseatData),
      GetKeyMessageDataPage: this.post.bind(this, API.MAP.GetKeyMessageDataPage),
      AddKeyMessage: this.post.bind(this, API.MAP.AddKeyMessage),
      getPathList: this.post.bind(this, API.MAP.getPathList),
      updatePathData: this.post.bind(this, API.MAP.updatePathData),
      deletePathData: this.post.bind(this, API.MAP.deletePathData),
      addPathData: this.post.bind(this, API.MAP.addPathData),
    }
    this.chat = {
      uploadFile: this.post.bind(this, API.CHAT.uploadFile),
      loginChat: this.post.bind(this, API.CHAT.loginChat),
      GetRoomId: this.post.bind(this, API.CHAT.GetRoomId),
      getMore: this.post.bind(this, API.CHAT.getMore),
      changeNewsStatus: this.post.bind(this, API.CHAT.changeNewsStatus),
      loginOut: this.post.bind(this, API.CHAT.loginOut),
      getRoomHistory: this.post.bind(this, API.CHAT.getRoomHistory),
      ECMDownloadFile: this.post.bind(this, API.CHAT.ECMDownloadFile),
      quitRoom: this.post.bind(this, API.CHAT.quitRoom),
      getUserHeadPic: this.post.bind(this, API.CHAT.getUserHeadPic),
      ECMCreateRoom: this.post.bind(this, API.CHAT.ECMCreateRoom)
    }
    this.org = {
      getDepartByIdentId: this.get.bind(this, API.ORG.getDepartByIdentId),
      getChildDepartByIdentId: this.get.bind(this, API.ORG.getChildDepartByIdentId),
      getPosByIdentId: this.get.bind(this, API.ORG.getPosByIdentId),
      getChildPosByIdentId: this.get.bind(this, API.ORG.getChildPosByIdentId),
      getGroupList: this.get.bind(this, API.ORG.getGroupList),
      searchMember: this.post.bind(this, API.ORG.searchMember)
    },
    this.amis = {
      getAmisDataPage: this.post.bind(this, API.AMIS.getAmisDataPage),
      getAmisDataPage: this.post.bind(this, API.AMIS.getAmisDataPage),
      getCorrosionTaskData: this.post.bind(this, API.AMIS.getCorrosionTaskData),
      updateCorrosionTask: this.post.bind(this, API.AMIS.updateCorrosionTask),
      getPidSvgList: this.post.bind(this, API.AMIS.getPidSvgList),
      getAreaList: this.post.bind(this, API.AMIS.getAreaList),
      getDeviceMaintainLog: this.post.bind(this, API.AMIS.getDeviceMaintainLog),
      excuteImage: this.post.bind(this, API.AMIS.excuteImage),
      getCadMpy: this.post.bind(this, API.AMIS.getCadMpy),
      getCorrosionMpy: this.post.bind(this, API.AMIS.getCorrosionMpy),
      getWallThickMpy: this.post.bind(this, API.AMIS.getWallThickMpy),
      exportWallThickR: this.post.bind(this, API.AMIS.exportWallThickR),
      excuteDWG: this.post.bind(this, API.AMIS.excuteDWG),
      addPsData: this.post.bind(this, API.AMIS.addPsData),
      getPsData: this.post.bind(this, API.AMIS.getPsData),
      taskImport: this.post.bind(this, API.AMIS.taskImport),
      getCorrosionMpyData: this.post.bind(this, API.AMIS.getCorrosionMpyData)
    },
    this.collect = {
      getCollectList: this.post.bind(this, API.COLLECT.getCollectList), //自己区域收藏
      getAllCollectList: this.post.bind(this, API.COLLECT.getAllCollectList),//所有区域
      getAllFileLIst: this.post.bind(this, API.COLLECT.getAllFileLIst), //获取所有收藏夹
      addArea: this.post.bind(this, API.COLLECT.addArea),//增加区域收藏
      deleteArea: this.post.bind(this, API.COLLECT.deleteArea), //区域删除
      addFile: this.post.bind(this, API.COLLECT.addFile),
      deleteCollect: this.post.bind(this, API.COLLECT.deleteCollect),
      updateCollectFile: this.post.bind(this, API.COLLECT.updateCollectFile),
      getNumber: this.post.bind(this, API.COLLECT.getNumber),
      getPersonList: this.post.bind(this, API.COLLECT.getPersonList),
      addPersonList: this.post.bind(this, API.COLLECT.addPersonList),
      setPersonaList: this.post.bind(this, API.COLLECT.setPersonaList),
      addUserPrivileges: this.post.bind(this, API.COLLECT.addUserPrivileges)
    },
    this.head = {
      HeadUpload: this.post.bind(this, API.HEAD.HeadUpload),
      getEcmHead: this.get.bind(this, API.HEAD.getEcmHead),
      upSpcHead: this.post.bind(this, API.HEAD.upSpcHead),
      getSourceFace: this.get.bind(this, API.HEAD.getSourceFace),
      imgCut: this.post.bind(this, API.HEAD.imgCut)
    },
    this.tables = {
      getDayReport: this.post.bind(this, API.TABLES.getDayReport),
      getLaboratoryData: this.post.bind(this, API.TABLES.getLaboratoryData),
      setLaboratoryData: this.post.bind(this, API.TABLES.setLaboratoryData),
      getProductOut: this.post.bind(this, API.TABLES.getProductOut),
      setProductOut: this.post.bind(this, API.TABLES.setProductOut),
      getComprehensiveDaily: this.post.bind(this, API.TABLES.getComprehensiveDaily),
      GetCalTime: this.post.bind(this, API.TABLES.GetCalTime),
      setDailyReport: this.post.bind(this, API.TABLES.setDailyReport),
      GetBigScreenWarnData: this.post.bind(this, API.TABLES.GetBigScreenWarnData),
      GetBaseData: this.post.bind(this, API.TABLES.GetBaseData),
      getBiData: this.post.bind(this, API.TABLES.getBiData),
      addPollingTrackRoute: this.post.bind(this, API.TABLES.addPollingTrackRoute),
      getPollingTrackRouteLIst: this.post.bind(this, API.TABLES.getPollingTrackRouteLIst),
      getProductData: this.post.bind(this, API.TABLES.getProductData),
      getDcsHistory: this.post.bind(this, API.TABLES.getDcsHistory),
      getHSEManage: this.post.bind(this, API.TABLES.getHSEManage),
      getBIBusiness: this.post.bind(this, API.TABLES.getBIBusiness),
      getDcsFactDevice: this.post.bind(this, API.TABLES.getDcsFactDevice),
      getHseTVDataList: this.post.bind(this, API.TABLES.getHseTVDataList),
      getRealDataLog: this.post.bind(this, API.TABLES.getRealDataLog),
      clearData: this.post.bind(this, API.TABLES.clearData)
    },
    this.warn = {
      addWarn: this.post.bind(this, API.warn.addWarn),
      searchWarn: this.post.bind(this, API.warn.searchWarn)
    },
    this.hys = {
      getHysTime: this.post.bind(this, API.HYS.getHysTime),
      setHysTime: this.post.bind(this, API.HYS.setHysTime),
      getHysDataTable: this.post.bind(this, API.HYS.getHysDataTable),
      getBestResult: this.post.bind(this, API.HYS.getBestResult),
      GetHysysReportData: this.post.bind(this, API.HYS.GetHysysReportData),
      setDailyReport: this.post.bind(this, API.TABLES.setDailyReport),
      GetHysysOptimizeParam: this.post.bind(this, API.HYS.GetHysysOptimizeParam),
      StartHysysFigureup: this.post.bind(this, API.HYS.StartHysysFigureup),
      EndHysysFigureup: this.post.bind(this, API.HYS.EndHysysFigureup),
      GetHysysRroPriceData: this.post.bind(this, API.HYS.GetHysysRroPriceData),
      GetWarringData: this.post.bind(this, API.HYS.GetWarringData),
      GetEnergyData: this.post.bind(this, API.HYS.GetEnergyData),
      GetEnergyPriceDataList: this.post.bind(this, API.HYS.GetEnergyPriceDataList),
    },
    this.exportReport = {
      exportLaboratoryData: this.post.bind(this, API.exportReport.exportLaboratoryData),
      exportComprehensiveDaily: this.post.bind(this, API.exportReport.exportComprehensiveDaily),
      exportProductOut: this.post.bind(this, API.exportReport.exportProductOut),
      exportDailyReportt: this.post.bind(this, API.exportReport.exportDailyReportt),
      exportHysysReportData: this.post.bind(this, API.exportReport.exportHysysReportData)
    },
    this.warn = {
      addWarn: this.post.bind(this, API.warn.addWarn),
      searchWarn: this.post.bind(this, API.warn.searchWarn)
    },
    this.views = {
      addView: this.post.bind(this, API.views.addView),
      editView: this.post.bind(this, API.views.editView),
      deleteView: this.post.bind(this, API.views.deleteView),
      getViewList: this.post.bind(this, API.views.getViewList),
      setDefault: this.post.bind(this, API.views.setDefault),
      getRoam: this.post.bind(this, API.views.getRoam),
      delRoam: this.post.bind(this, API.views.delRoam),
      addRoam: this.post.bind(this, API.views.addRoam),
      addRoamPath: this.post.bind(this, API.views.addRoamPath),
      getRoamPath: this.post.bind(this, API.views.getRoamPath),
      delRoamPath: this.post.bind(this, API.views.delRoamPath),
      getSvgPid: this.post.bind(this, API.views.getSvgPid),
      getDcsData: this.post.bind(this, API.views.getDcsData)
    },
    this.viewManagement = {
      getSignListL: this.post.bind(this, API.viewManagement.getSignListL),
      deleteSign: this.post.bind(this, API.viewManagement.deleteSign),
      addSing: this.post.bind(this, API.viewManagement.addSing)
    }
    this.dash = {
      GetRealTimeDataList: this.post.bind(this, API.DASH.GetRealTimeDataList),
      GetEtchPlanDataList: this.post.bind(this, API.DASH.GetEtchPlanDataList),
      GetCorrosionMpyDatalist: this.post.bind(this, API.DASH.GetCorrosionMpyDatalist),
      GetWallThicknessData: this.post.bind(this, API.DASH.GetWallThicknessData),
    }
    this.biView = {
      getBiData: this.post.bind(this, API.BiView.getBiData)
    }
  }


  get(url, params) {
    // const loadingInstance = Loading.service({ text: '加载中...' })
    if (params) {
      url += encodeParams(params)
    }
    if (localStorage.token) {
      Http.defaults.headers.common['access_token'] = localStorage.token
    }
    return Http.get(url)
      .then(res => {
        setTimeout(function () {
          // loadingInstance.close()
        }, 500)
        return res.data
      })
      .catch(function () {
        // loadingInstance.close()
      })
  }

  post(url, data) {
    if (localStorage.token) {
      Http.defaults.headers.common['access_token'] = localStorage.token
    } else if (url !== '/api/UserCenter/userLogin' && !localStorage.token) {
      window.location.href = '/login'
    }
    typeof data === 'undefined' ? (data = {}) : ''
    return Http.post(url, data)
      .then(res => {
        setTimeout(function () {
        }, 1000)
        return res.data
      })
      .catch(function () {
      })
  }
}

// 导出一个对象
export default new ApiService()


// WEBPACK FOOTER //
// ./src/services/API-services.js